import React from 'react';

interface AddSelectableItemProps {
  text?: string;
  onClick?: () => void;
}

const AddSelectableItem: React.FC<AddSelectableItemProps> = ({
  text = 'Select item',
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '8px 0',
        cursor: 'pointer',
      }}
    >
      <div
        style={{
          backgroundColor: 'var(--light-gray)',
          width: '28px',
          height: '28px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '600',
          fontSize: '12px',
          color: 'var(--text-primary)',
        }}
      >
        +
      </div>
      <div
        style={{
          fontWeight: 600,
          fontSize: '12px',
          color: 'var(--text-primary)',
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default AddSelectableItem;
